import React, { useCallback, useEffect } from "react";

import { Button, Dialog, DialogActions } from "@material-ui/core";
import html2pdf from "html2pdf.js";

import toastError from "../../errors/toastError";

const TicketMessagesDialog = ({ open, handleClose, ticketId }) => {
  const handleExportToPDF = useCallback(() => {
    const messagesListElement = document.getElementById("messagesList");
    const headerElement = document.getElementById("TicketHeader");

    const pdfOptions = {
      margin: 1,
      filename: `relatório_atendimento_${ticketId}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    if (!messagesListElement || !headerElement) {
      toastError("Elemento não encontrado para exportar.");
      return;
    }

    const headerClone = headerElement.cloneNode(true);
    const messagesListClone = messagesListElement.cloneNode(true);

    const containerElement = document.createElement("div");
    containerElement.appendChild(headerClone);
    containerElement.appendChild(messagesListClone);

    html2pdf().from(containerElement).set(pdfOptions).save();
  }, [ticketId]);

  useEffect(() => {
    if (open) {
      handleExportToPDF();
      handleClose();
    }
  }, [open, handleClose, handleExportToPDF]);

  return (
    <Dialog maxWidth="md" onClose={handleClose} open={open}>
      <DialogActions>
        <Button onClick={handleExportToPDF} color="primary">
          Exportar para PDF
        </Button>
        <Button onClick={handleClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketMessagesDialog;
